'use strict';
import template from '../../layouts/edit-form/edit-form.html';
import EditFormCtrl from '../../layouts/edit-form/edit-form';

MxMultiFragmentTreeviewCtrl.$inject = [
	'$scope',
	'$q',
	'mx.shell.DetailsView',
	'mx.internationalization',
	'mx.shell.SidePanelService',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'mx.shell.NotificationService',
];
export default function MxMultiFragmentTreeviewCtrl($scope, $q, DetailsView, i18n, sidePanelService, contentWidgetService, notificationService) {
	var vm = this;
	var addProxyFunc;
	vm.$onInit = function () {
		vm.parentField = vm.parentField || 'Parent';
		vm.idField = vm.idField || 'ID';
		vm.editInForm = vm.editInForm === 'true';
		vm._showAdd = true;
		vm._showEdit = vm.editInForm;
		vm._showDelete = true;
		addProxyFunc = vm.editInForm ? loadForm : initItem;
		initScope();
	};

	vm.add = function (item) {
		if (vm.newEntity) {
			addProxyFunc(true, item);
		} else {
			contentWidgetService.getNewFragment(vm.className).then(
				function (entity) {
					vm.newEntity = entity;
					vm.newEntity.ID = null;
					addProxyFunc(true, item);
				},
				function () {}
			);
		}
	};

	vm.delete = function (item) {
		notificationService
			.confirm(
				i18n.get('solutionBuilderAgent.components.mx-search-query-builder.delete'),
				i18n.get('solutionBuilderAgent.components.mx-search-query-builder.confirmDelete'),
				i18n.get('solutionBuilderAgent.actions.operation-action.yes'),
				i18n.get('solutionBuilderAgent.actions.operation-action.no')
			)
			.then(function () {
				mx.components.Treeview.DeleteItem(vm, item);
			});
	};

	vm.edit = function () {
		loadForm(false);
	};

	function initItem(p, item) {
		addItem(createItem(item || null));
	}

	function createItem(item) {
		var currentItem = angular.copy(vm.newEntity);
		currentItem[vm.idField] = mx.components.Utils.guid();

		if (item) {
			currentItem[vm.parentField] = item[vm.idField];
		}

		return currentItem;
	}

	function loadForm(isAddingNew, item) {
		var objectForCancel;
		var currentItem;
		if (isAddingNew) {
			currentItem = createItem(item);
		} else {
			currentItem = vm.selectedItem;
			objectForCancel = angular.copy(currentItem);
		}

		var dialogName = 'Treeview Editor';
		var formView = new DetailsView({
			id: isAddingNew ? 'add-new-item' : 'edit-item' + currentItem[vm.idField],

			name: dialogName,
			displayName: dialogName,
			controller: EditFormCtrl,
			locals: {
				item: currentItem,
				templateId: vm.templateFormId,
				dataModel: $scope[vm.parentControllerAs].dataModel, //vm.mxForm ? vm.mxForm.entity : null,

				cancelLabel: i18n.get('solutionBuilderAgent.common.cancel_btn'),
				saveLabel: 'OK',
			},
			template: template,
		});

		sidePanelService
			.addView(formView, vm.parentViewController && vm.parentViewController.mxView)
			.then(updateEntity, cancel)
			.catch(mx.logCatch);

		function updateEntity() {
			if (isAddingNew) {
				addItem(currentItem);
			}
		}

		function cancel() {
			if (objectForCancel) {
				mx.SolutionBuilderAgent.ExtendDeep(currentItem, objectForCancel);
			}
		}
	}

	function addItem(item) {
		vm.items = (vm.items || []).concat([item]);
		vm.selectedItem = item;
	}

	function initScope() {
		if (vm.parentControllerAs) {
			$scope[vm.parentControllerAs] = $scope.$parent[vm.parentControllerAs];
		} else {
			$scope.dataModel = $scope.$parent;
		}
	}

	return vm;
}

function MxMultiFragmentTreeview() {
	var directive = new mx.components.Treeview();

	directive.controller = MxMultiFragmentTreeviewCtrl;

	angular.extend(directive.bindToController, {
		templateFormId: '@',
		className: '@',
		items: '=?',
		editInForm: '@',
	});

	angular.extend(directive.require, {
		parentViewController: '?^^mxView',
	});

	directive.templateUrl = 'workspaces/SolutionBuilderAgent/components/mx-treeview/mx-multi-fragment-treeview.html';

	return directive;
}

angular.module('mx.SolutionBuilderAgent').directive('mxMultiFragmentTreeview', MxMultiFragmentTreeview);
